import { Typography as Text } from '@mui/material'

export default Text
